<template>
	<el-dialog title="司机详情" v-model="isDetail" width="80%" center :close-on-click-modal="false"
		@closed="dialogClosedHandle">
		<div class="dialog-container scroll-view" style="max-height: 600px; overflow: auto">
			<p class="platTitle">基础信息</p>
			<div class="info-input-container">
				<div class="flex flex-y-center flex-wrap">
					<div class="w50 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span class="input-fail">*</span>
							<span>司机名称</span>
						</div>
						<el-input v-model="driName" class="platItemRigth" placeholder="请输入" />
					</div>
					<div class="w50 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span class="input-fail">*</span>
							<span>身份证号:</span>
						</div>
						<el-input v-model="driCardid" class="platItemRigth" placeholder="请输入" />
					</div>
					<div class="w50 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span class="input-fail">*</span>
							<span>手机号:</span>
						</div>
						<el-input v-model="driPhone" class="platItemRigth" placeholder="请输入" />
					</div>
					<div class="w50 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span class="input-fail">*</span>
							<span>性别:</span>
						</div>
						<div class="flex platItemRigth flex-y-center">
							<el-select v-model="driSex" placeholder="性别">
								<el-option label="男" value="0" />
								<el-option label="女" value="1" />
							</el-select>
						</div>
					</div>
					<div class="w50 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span class="input-fail">*</span>
							<span>紧急联系人:</span>
						</div>
						<el-input v-model="driEmcontact" class="platItemRigth" placeholder="请输入" />
					</div>
					<div class="w50 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span class="input-fail">*</span>
							<span>紧急联系电话:</span>
						</div>
						<el-input v-model="driEmphone" class="platItemRigth" placeholder="请输入" />
					</div>
					<div class="w50 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span class="input-fail">*</span>
							<span>居住地址:</span>
						</div>
						<el-input v-model="driHabitancy" class="platItemRigth" placeholder="请输入" />
					</div>
					<div class="w50 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span class="input-fail">*</span>
							<span>类型:</span>
						</div>
						<div class="flex platItemRigth flex-y-center">
							<el-select v-model="driType" placeholder="性别">
								<el-option label="加盟" value="0" />
								<el-option label="外调" value="1" />
								<el-option label="临时" value="2" />
							</el-select>
						</div>
					</div>
					<div class="w50 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span class="input-fail">*</span>
							<span>备注:</span>
						</div>
						<el-input v-model="driRemark" class="platItemRigth" placeholder="请输入" />
					</div>

				</div>
			</div>
			<p class="platTitle">驾驶证信息</p>
			<div class="info-input-container">
				<div class="flex flex-y-center flex-wrap">
					<div class="w50">
						<div class="flex flex-y-center platItem">
							<div class="flex flex-y-center platItemLeft">
								<span class="input-fail">*</span>
								<span>驾驶证号</span>
							</div>
							<el-input v-model="drilLicenseId" class="platItemRigth" placeholder="请输入" />
						</div>
						<div class="flex flex-y-center platItem">
							<div class="flex flex-y-center platItemLeft">
								<span class="input-fail">*</span>
								<span>驾驶证档案编号</span>
							</div>
							<el-input v-model="drilArchiveNo" class="platItemRigth" placeholder="请输入" />
						</div>
						<div class="flex flex-y-center platItem">
							<div class="flex flex-y-center platItemLeft">
								<span class="input-fail">*</span>
								<span>驾驶证发证机关</span>
							</div>
							<el-input v-model="drilInstitutionSeal" class="platItemRigth" placeholder="请输入" />
						</div>
						<div class="flex flex-y-center platItem">
							<div class="flex flex-y-center platItemLeft">
								<span class="input-fail">*</span>
								<span>驾驶证发证日期</span>
							</div>
							<div class="flex platItemRigth flex-y-center">
								<el-date-picker v-model="drilIssueDate" type="date" :clearable="false"
									placeholder="请选择驾驶证发证日期">
								</el-date-picker>
							</div>
						</div>
						<div class="flex flex-y-center platItem">
							<div class="flex flex-y-center platItemLeft">
								<span class="input-fail">*</span>
								<span>驾驶证起始日期</span>
							</div>
							<div class="flex platItemRigth flex-y-center">
								<el-date-picker v-model="drilStartDate" type="date" :clearable="false"
									placeholder="请选择驾驶证起始日期">
								</el-date-picker>
							</div>
						</div>
						<div class="flex flex-y-center platItem">
							<div class="flex flex-y-center platItemLeft">
								<span class="input-fail">*</span>
								<span>驾驶证到期日期</span>
							</div>
							<div class="flex platItemRigth flex-y-center">
								<el-date-picker v-model="drilEndDate" type="date" :clearable="false"
									placeholder="请选择驾驶证到期日期">
								</el-date-picker>
							</div>
						</div>
					</div>
					<div class="w50 platItem flex" style="align-items: flex-start" ref="refdril">
						<div class="flex flex-y-center platItemLeft">
							<span>驾驶证照</span>
						</div>
						<div class="flex flex-y-center flex-x-between platItemRigth" >
							<div class="upRpic_icon_item2" v-if="drilPhotoUrl == ''">
								<img class="upRpic_icon" src="@/assets/images/upload-icon.png" />
								<span class="fontSize14 col-999">上传图片</span>
							</div>
							<div class="upRpic_icon_item2" v-else>
								<img class="upRpic2_icon" :data-original="drilPhotoUrl" :src="drilPhotoUrl" />
							</div>
						</div>
					</div>
				</div>
			</div>
			<p class="platTitle">从业资格证信息</p>
			<div class="info-input-container">
				<div class="flex flex-y-center flex-wrap">
					<div class="w50">
						<div class="flex flex-y-center platItem">
							<div class="flex flex-y-center platItemLeft">
								<span class="input-fail">*</span>
								<span>资格证编号</span>
							</div>
							<el-input v-model="drjcNo" class="platItemRigth" placeholder="请输入" />
						</div>
						<div class="flex flex-y-center platItem">
							<div class="flex flex-y-center platItemLeft">
								<span class="input-fail">*</span>
								<span>从业日期</span>
							</div>
							<div class="flex platItemRigth flex-y-center">
								<el-date-picker v-model="drjcJobDate" type="date" :clearable="false"
									placeholder="请选择从业日期">
								</el-date-picker>
							</div>
						</div>
						<div class="flex flex-y-center platItem">
							<div class="flex flex-y-center platItemLeft">
								<span class="input-fail">*</span>
								<span>资格证发证日</span>
							</div>
							<div class="flex platItemRigth flex-y-center">
								<el-date-picker v-model="drjcStartDate" type="date" :clearable="false"
									placeholder="请选择资格证发证日">
								</el-date-picker>
							</div>
						</div>
						<div class="flex flex-y-center platItem">
							<div class="flex flex-y-center platItemLeft">
								<span class="input-fail">*</span>
								<span>资格证到期日</span>
							</div>
							<div class="flex platItemRigth flex-y-center">
								<el-date-picker v-model="drjcEndDate" type="date" :clearable="false"
									placeholder="请选择资格证到期日">
								</el-date-picker>
							</div>
						</div>
						<div class="flex flex-y-center platItem">
							<div class="flex flex-y-center platItemLeft">
								<span class="input-fail">*</span>
								<span>道路经营许可证号</span>
							</div>
							<el-input v-model="drjcTransportLicense" class="platItemRigth" placeholder="请输入" />
						</div>
					</div>
					<div class="w50 platItem flex" style="align-items: flex-start" ref="refdrjc">
						<div class="flex flex-y-center platItemLeft">

							<span>从业资格证照</span>
						</div>
						<div class="flex flex-y-center flex-x-between platItemRigth" >
							<div class="upRpic_icon_item2" v-if="drjcPhotoUrl == ''">
								<img class="upRpic_icon" src="@/assets/images/upload-icon.png" />
								<span class="fontSize14 col-999">上传图片</span>
							</div>
							<div class="upRpic_icon_item2" v-else>
								<img class="upRpic2_icon" :data-original="drjcPhotoUrl" :src="drjcPhotoUrl" />
							</div>
						</div>
					</div>
				</div>
			</div>

			<span class="dialog-footer">
				<span class="btn bg-default" v-on:click="closeModal()">关闭</span>
			</span>
		</div>
	</el-dialog>
</template>

<script>
	import {
		defineComponent,
		reactive,
		toRefs,
		getCurrentInstance,
		onMounted,
		nextTick,
	} from "vue";
	import {
		imgFileToBase64,
		isChinese
	} from "@/libs/tools";
	import {
		useStore
	} from "vuex";
	import {
		apiObj
	} from "@/config/api";
	import Viewer from "viewerjs";
	import "viewerjs/dist/viewer.css";
	export default defineComponent({
		name: "Edit",

		emits: ["getData"],
		setup(props, context) {
			const store = useStore();
			const {
				proxy
			} = getCurrentInstance();

			const getData = () => {
				context.emit("getData");
			};
			onMounted(() => {});
			const data = reactive({
				isDetail: false,
				driUserId: "",
				driOrg: "2", //所属机构
				driOrgUsing: "0", //机构级别 0本机构1本级及下级2本级及下级所有
				driCardid: "", //身份证号
				driName: "", //司机名称
				driPhone: "", //手机号
				driType: "0", //司机类型0加盟1外调2临时
				driDriveType: "2", //准驾车型
				driSex: "0", //性别0男1女
				driSaler: "2", //招商顾问
				driSource: "2", //信息来源
				driIntention: "2", //意向程度0高1中2低3无意向
				driWeixin: "", //微信号
				driEmcontact: "", //紧急联系人
				driEmphone: "", //紧急联系电话
				driHabitancy: "", //居住地
				driRemark: "", //备注
				drjcNo: "", //从业资格证编号
				drjcJobDate: "", //从业日期
				drjcStartDate: "", //从业资格证发证日
				drjcEndDate: "", //从业资格证到期日
				drjcTransportLicense: "", //道路经营许可证
				drjcPhotoUrl: "http", //从业资格证图片
				drilLicenseId: "", //驾驶证号
				drilArchiveNo: "", //驾驶证档案编号
				drilInstitutionSeal: "", //驾驶证发证机关
				drilIssueDate: "", //初次领证日期
				drilStartDate: "", //驾驶证起始日期
				drilEndDate: "", //驾驶证到期日期
				drilPhotoUrl: "http", //驾驶证照片
			});
			//重置数据
			const init = async (id) => {
				data.isDetail = true;
				data.driUserId = id;
				let params = {
					driUserId: id,
				};
				const r = await proxy.$http.get(apiObj.driDetail, params);
				if (r) {
					data.driOrg = r.driInfo.driOrg;
					data.driOrgUsing = r.driInfo.driOrgUsing;
					data.driCardid = r.driInfo.driCardid;
					data.driName = r.driInfo.driName;
					data.driPhone = r.driInfo.driPhone;
					data.driType = r.driInfo.driType;
					data.driDriveType = r.driInfo.driDriveType;
					data.driSex = r.driInfo.driSex;
					data.driSaler = r.driInfo.driSaler;
					data.driSource = r.driInfo.driSource;
					data.driIntention = r.driInfo.driIntention;
					data.driWeixin = r.driInfo.driWeixin;
					data.driEmcontact = r.driInfo.driEmcontact;
					data.driEmphone = r.driInfo.driEmphone;
					data.driHabitancy = r.driInfo.driHabitancy;
					data.driRemark = r.driInfo.driRemark;
					data.drjcNo = r.driJobCertificate.drjcNo;
					data.drjcJobDate = r.driJobCertificate.drjcJobDate;
					data.drjcStartDate = r.driJobCertificate.drjcStartDate;
					data.drjcEndDate = r.driJobCertificate.drjcEndDate;
					data.drjcTransportLicense = r.driJobCertificate.drjcTransportLicense;
					data.drjcPhotoUrl = r.driJobCertificate.drjcPhotoUrl;
					data.drilLicenseId = r.driLicense.drilLicenseId;
					data.drilArchiveNo = r.driLicense.drilArchiveNo;
					data.drilInstitutionSeal = r.driLicense.drilInstitutionSeal;
					data.drilIssueDate = r.driLicense.drilIssueDate;
					data.drilStartDate = r.driLicense.drilStartDate;
					data.drilEndDate = r.driLicense.drilEndDate;
					data.drilPhotoUrl = r.driLicense.drilPhotoUrl;
				}

				setTimeout(() => {
					lookImg();
				}, 1500);
			};

			const dialogClosedHandle = () => {
				data.isDetail = false;
			};
			const closeModal = () => {
				data.isDetail = false;
			};
			const submit = async () => {

				if (data.driName == "") {
					proxy.$message.error("请填写司机名称");
					return;
				}
				if (data.driPhone == "") {
					proxy.$message.error("请填写手机号");
					return;
				}

				let params = {
					driUserId: data.driUserId,
					driOrgUsing: data.driOrgUsing,
					driCardid: data.driCardid,
					driName: data.driName,
					driPhone: data.driPhone,
					driType: data.driType,
					driDriveType: data.driDriveType,
					driSex: data.driSex,
					driSaler: data.driSaler,
					driSource: data.driSource,
					driIntention: data.driIntention,
					driWeixin: data.driWeixin,
					driEmcontact: data.driEmcontact,
					driEmphone: data.driEmphone,
					driHabitancy: data.driHabitancy,
					driRemark: data.driRemark,
					driJobCertificate: {
						drjcNo: data.drjcNo,
						drjcJobDate: data.drjcJobDate,
						drjcStartDate: data.drjcStartDate,
						drjcEndDate: data.drjcEndDate,
						drjcTransportLicense: data.drjcTransportLicense,
						drjcPhotoUrl: data.drjcPhotoUrl
					},
					driLicense: {
						drilLicenseId: data.drilLicenseId,
						drilArchiveNo: data.drilArchiveNo,
						drilInstitutionSeal: data.drilInstitutionSeal,
						drilIssueDate: data.drilIssueDate,
						drilStartDate: data.drilStartDate,
						drilEndDate: data.drilEndDate,
						drilPhotoUrl: data.drilPhotoUrl
					}
				}

				const r = await proxy.$http.post(apiObj.driUpdate, params)
				console.log(r);
				if (r.code === 0 || r.respCode === '0000') {
					proxy.$message.success(r.msg || r.respMsg);
					getData();
					data.isAdd = false;
				} else {
					proxy.$message.error(r.msg || r.respMsg);
				}
			};
			//数组去重
			const uniqueArr = (array = []) => {
				var n = []; //一个新的临时数组
				//遍历当前数组
				for (var i = 0; i < array.length; i++) {
					//如果当前数组的第i已经保存进了临时数组，那么跳过，
					//否则把当前项push到临时数组里面
					if (n.indexOf(array[i]) == -1) n.push(array[i]);
				}
				return n;
			};
			//查看图片
			const lookImg = () => {
				const ref1Dom = proxy.$refs.refdril;
				if (ref1Dom != undefined) {
					const zfhtViewer = new Viewer(ref1Dom, {
						inline: false, // 不使用内联模式，强制弹出（使用内联样式就会在页面展示，不弹出）
						navbar: true, // 显示导航
						title: false, // 隐藏标题
						toolbar: true, // 显示工具栏
						zoomable: true, // 支持缩放
						rotatable: true, // 支持旋转
						scalable: true, // 支持缩放
						transition: true, // 启用过渡效果
						//    url: "data-original",
						// zIndex: 4000,
					});
				}
				const ref2Dom = proxy.$refs.refdrjc;
				if (ref2Dom != undefined) {
					const ingViewer = new Viewer(ref2Dom, {
						inline: false, // 不使用内联模式，强制弹出（使用内联样式就会在页面展示，不弹出）
						navbar: true, // 显示导航
						title: false, // 隐藏标题
						toolbar: true, // 显示工具栏
						zoomable: true, // 支持缩放
						rotatable: true, // 支持旋转
						scalable: true, // 支持缩放
						transition: true, // 启用过渡效果
						// url: "data-original",
						// zIndex: 4000,
					});
				}
			};

			return {
				...toRefs(data),
				init,
				closeModal,
				getData,
				dialogClosedHandle,
				submit,
				uniqueArr,
			};
		},
	});
</script>
<style scoped>
	.page_warp {
		width: 100%;
		max-height: 600px;
	}

	.input_row {
		width: 100%;
		height: 50px;
		display: flex;
		align-items: center;
	}

	.input_lable {
		width: 80px;
		text-align: right;
	}

	.input_box {
		width: 50%;
	}

	.input_tree_warp {
		width: calc(100% - 30px);
		height: 300px;
		margin-left: 30px;

		box-sizing: border-box;
		margin-top: 10px;
		display: flex;
		justify-content: space-between;
	}

	.manage {
		width: 48%;
		height: 100%;

		display: flex;
	}

	.tree {
		width: calc(100% - 80px);
		height: 100%;
		overflow: auto;
	}

	.footer_btn_warp {
		width: 100%;
		height: 70px;
		margin-top: 30px;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.cancle_btn {
		width: 116px;
		height: 38px;
		background: #e36a19;
		border-radius: 4px;
		text-align: center;
		color: #fff;
		font-size: 14px;
		line-height: 38px;
		cursor: pointer;
		margin-right: 90px;
	}

	.confirm_btn {
		width: 116px;
		height: 38px;
		background: #293787;
		border-radius: 4px;
		text-align: center;
		color: #fff;
		font-size: 14px;
		line-height: 38px;
		cursor: pointer;
	}

	.platTitle {
		line-height: 100px;
		font-size: 18px;
		color: #000;
		font-weight: 600;
		position: relative;
		padding-left: 20px;
	}

	.platTitle::before {
		content: "";
		width: 4px;
		height: 18px;
		background: #20ca68;
		border-radius: 2px;
		position: absolute;
		top: 42px;
		left: 10px;
	}

	.platItem {
		margin-bottom: 20px;
	}

	.platItemLeft {
		min-width: 100px;
		justify-content: flex-end;
	}

	.platItem input {
		width: 70%;
		height: 38px;
		border: 1px solid #ededed;
		border-radius: 4px;
		padding-left: 20px;
		box-sizing: border-box;
	}

	.platItemRigth {
		width: 70%;
		padding-left: 20px;
		box-sizing: border-box;
	}

	.platItemRigth img {
		width: 190px;
		height: 130px;
	}

	.dialog-footer {
		width: 100%;
		height: 70px;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.btn {
		padding: 5px 15px;
		font-size: 14px;
		border-radius: 5px;
		cursor: pointer;
	}
</style>